/**
 * A/B Test — ATC button "save $X (Y%) now" (second line)
 * Toggle: body[data-atc-save-now-ab="true|false"]
 */
(function () {
  'use strict';

  var ATTR = 'data-atc-save-now-ab';
  var SAVE_CLASS = 'buy-buttons__save-now';
  var ROW_CLASS = 'buy-buttons__primary-row';

  function isAbEnabled() {
    return document.body.getAttribute(ATTR) === 'true';
  }

  function parseMoneyToCents(text) {
    if (!text) return 0;
    var cleaned = String(text).replace(/[^0-9.,]/g, '').trim();
    if (!cleaned) return 0;
    var hasComma = cleaned.indexOf(',') !== -1;
    var hasDot = cleaned.indexOf('.') !== -1;
    if (hasComma && hasDot) {
      if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    } else if (hasComma && !hasDot) {
      cleaned = cleaned.replace(',', '.');
    }
    var value = parseFloat(cleaned);
    if (isNaN(value)) return 0;
    return Math.round(value * 100);
  }

  function extractCurrencySymbol(text) {
    if (!text) return '$';
    var match = String(text).match(/^[^\d\s-]+/);
    return match ? match[0].trim() : '$';
  }

  function formatCents(cents, symbol) {
    var abs = Math.abs(cents);
    var dollars = (abs / 100).toFixed(2);
    return (symbol || '$') + dollars;
  }

  function getPriceNodes(button) {
    var compareEl =
      button.querySelector('.buy-buttons__compare-price') ||
      button.querySelector('s.igComparePrice') ||
      button.querySelector('.satc-old-price-btn');
    var priceEl =
      button.querySelector('.buy-buttons__price--sale') ||
      button.querySelector('.buy-buttons__price') ||
      button.querySelector('.igPrice') ||
      button.querySelector('.satc-new-price-btn');
    return { compareEl: compareEl, priceEl: priceEl };
  }

  function ensurePrimaryRow(button) {
    var content = button.querySelector(':scope > div') || button;
    var existing = content.querySelector('.' + ROW_CLASS);
    if (existing) return existing;

    var row = document.createElement('span');
    row.className = ROW_CLASS;

    var moveNodes = [];
    Array.prototype.forEach.call(content.childNodes, function (node) {
      if (node.nodeType === 1 && node.classList && node.classList.contains(SAVE_CLASS)) return;
      if (node.nodeType === 1 && node.classList && node.classList.contains('button__loader')) return;
      moveNodes.push(node);
    });

    moveNodes.forEach(function (node) {
      row.appendChild(node);
    });

    var loader = content.querySelector('.button__loader');
    if (loader) {
      content.insertBefore(row, loader);
    } else {
      content.appendChild(row);
    }
    return row;
  }

  function ensureSaveEl(button) {
    var content = button.querySelector(':scope > div') || button;
    var saveEl = content.querySelector('.' + SAVE_CLASS);
    if (saveEl) return saveEl;

    ensurePrimaryRow(button);
    saveEl = document.createElement('span');
    saveEl.className = SAVE_CLASS;
    saveEl.setAttribute('aria-hidden', 'true');
    saveEl.hidden = true;

    var row = content.querySelector('.' + ROW_CLASS);
    var loader = content.querySelector('.button__loader');
    if (row && row.nextSibling) {
      content.insertBefore(saveEl, row.nextSibling);
    } else if (loader) {
      content.insertBefore(saveEl, loader);
    } else {
      content.appendChild(saveEl);
    }
    return saveEl;
  }

  function updateButton(button) {
    if (!button) return;

    var saveEl = ensureSaveEl(button);
    if (!isAbEnabled()) {
      saveEl.hidden = true;
      saveEl.textContent = '';
      button.classList.remove('atc-save-now--active');
      return;
    }

    var nodes = getPriceNodes(button);
    if (!nodes.priceEl) {
      saveEl.hidden = true;
      button.classList.remove('atc-save-now--active');
      return;
    }

    var priceCents = parseMoneyToCents(nodes.priceEl.textContent);
    var compareCents = nodes.compareEl ? parseMoneyToCents(nodes.compareEl.textContent) : 0;
    var savings = compareCents - priceCents;

    if (!(compareCents > priceCents) || savings <= 0) {
      saveEl.hidden = true;
      saveEl.textContent = '';
      button.classList.remove('atc-save-now--active');
      return;
    }

    var pct = Math.round((savings / compareCents) * 100);
    var symbol = extractCurrencySymbol(nodes.priceEl.textContent || nodes.compareEl.textContent);
    saveEl.textContent = 'Save  Now ' + formatCents(savings, symbol);
    saveEl.hidden = false;
    button.classList.add('atc-save-now--active');
  }

  function updateAll() {
    document
      .querySelectorAll(
        '.product-info__buy-buttons buy-buttons button[type="submit"], buy-buttons button[type="submit"], #satc-submit'
      )
      .forEach(updateButton);
  }

  var debounceTimer;
  var updating = false;

  function scheduleUpdate() {
    if (updating) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      updating = true;
      try {
        updateAll();
      } finally {
        updating = false;
      }
    }, 60);
  }

  function isBundleLockedNode(node) {
    if (!node) return false;
    if (node.nodeType === 1) {
      return node.getAttribute('data-bundle-price-locked') === 'true' ||
        !!(node.closest && node.closest('[data-bundle-price-locked="true"]'));
    }
    if (node.parentElement) {
      return node.parentElement.getAttribute('data-bundle-price-locked') === 'true' ||
        !!(node.parentElement.closest && node.parentElement.closest('[data-bundle-price-locked="true"]'));
    }
    return false;
  }

  function shouldIgnoreDomMutation(mutation) {
    var target = mutation.target;
    if (!target) return false;

    if (mutation.type === 'characterData' && isBundleLockedNode(target)) {
      return true;
    }

    if (target.nodeType === 1 && target.classList && target.classList.contains(SAVE_CLASS)) {
      return true;
    }

    if (target.parentElement && target.parentElement.classList && target.parentElement.classList.contains(SAVE_CLASS)) {
      return true;
    }

    if (mutation.type === 'attributes' && mutation.attributeName === 'data-bundle-price-locked') {
      return true;
    }

    return false;
  }

  function init() {
    updateAll();

    document.addEventListener('variant:change', scheduleUpdate);
    document.addEventListener('product:rerender', scheduleUpdate);
    document.addEventListener('bundle-selector:price-update', scheduleUpdate);

    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === ATTR) scheduleUpdate();
      });
    });
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: [ATTR] });

    var root = document.querySelector('.product-info') || document.body;
    var domObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (shouldIgnoreDomMutation(mutations[i])) {
          continue;
        }
        scheduleUpdate();
        break;
      }
    });
    domObserver.observe(root, {
      childList: true,
      subtree: true
    });

    // Sticky ATC lives outside .product-info and rewrites often
    var stickyRoot = document.getElementById('custom-sticky-atc');
    if (stickyRoot) {
      domObserver.observe(stickyRoot, { childList: true, subtree: true });
    } else {
      var stickyWatch = new MutationObserver(function () {
        var sticky = document.getElementById('custom-sticky-atc');
        if (sticky) {
          domObserver.observe(sticky, { childList: true, subtree: true });
          stickyWatch.disconnect();
          scheduleUpdate();
        }
      });
      stickyWatch.observe(document.body, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AtcSaveNowAb = {
    refresh: updateAll,
    isEnabled: isAbEnabled
  };
})();
